import { compact, first } from 'lodash';
import { HintType } from '../providers/FindTheLetterProvider/types';
import { FindTheLetterInterface } from '../providers/GameProvider/types';
import { LetterConstants } from '../types';

export const getFindTheLetterTotal = (currentData: FindTheLetterInterface): number =>
  currentData?.contents?.occurrences || 0;

export const buildSentenceData = (pageData: FindTheLetterInterface) => {
  return pageData?.contents?.description
    ? pageData.contents.description.split(' ').map((word: string) => word + '  ')
    : [];
};

export const isCorrectLetter = (activityLetter: string, currentLetter: string): boolean =>
  activityLetter.toUpperCase() === currentLetter.toUpperCase();

export const isFoundLetterCorrect = (pageData, letterId: string): boolean =>
  pageData?.foundLetters?.[letterId] === LetterConstants.CORRECT;

export const isFoundLetterWrong = (pageData, letterId: string): boolean =>
  pageData?.foundLetters?.[letterId] === LetterConstants.WRONG;

export const buildLetterId = (wordIndex: number, letterIndex: number): string =>
  `${wordIndex}:${letterIndex}`;

export const letterIsHint = (letterId: string, pageNumber: number, hint: HintType) =>
  hint.letterId === letterId && hint.pageNumber === pageNumber;

export const findHintInWord = (
  word: string,
  wordIndex: number,
  activityLetter: string,
  pageData
): string | null => {
  const correctNotFoundLetterIndex = word
    .split('')
    .findIndex(
      (eachLetter, letterIndex) =>
        isCorrectLetter(activityLetter, eachLetter) &&
        !isFoundLetterCorrect(pageData, buildLetterId(wordIndex, letterIndex))
    );

  return correctNotFoundLetterIndex >= 0
    ? buildLetterId(wordIndex, correctNotFoundLetterIndex)
    : null;
};

export const findHintInSentence = (
  currentPageData: FindTheLetterInterface,
  pages,
  activityLetter: string
): string | undefined =>
  first(
    compact(
      buildSentenceData(currentPageData).map((word, wordIndex) =>
        findHintInWord(word, wordIndex, activityLetter, pages[currentPageData.page.pageNumber])
      )
    )
  );

export const getLetterHintForPages = (
  currentData: FindTheLetterInterface[],
  pages,
  activityLetter: string
): HintType | undefined =>
  first(
    compact(
      currentData?.map((currentPageData) => {
        const hintLetterId = findHintInSentence(currentPageData, pages, activityLetter);
        return hintLetterId
          ? ({
              letterId: hintLetterId,
              pageNumber: currentPageData.page.pageNumber,
            } as HintType)
          : null;
      })
    )
  );
